export default {
  "units": {
    "days": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["days"])}
  },
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover this trail"])},
  "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save Trail"])},
  "like": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["like"])},
  "hiked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I hiked this trail !"])},
  "notHiked": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You have hiked this trail !"])},
  "hikedHover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click on this button if you have hiked this trail."])},
  "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Short Description"])}
}